// src/views/kiddo-games/repeat/WordFromList.tsx
// Kopia src/components/Repeat/WordFromList.tsx — tylko dla Powtórz Easy
import React, { FC } from 'react';
import { FitText } from '../../../components/FitText/FitText';
import classes from './WordFromList.module.less';

type CardProps = {
  id: any,
  content: any,
  style: any,
};

export const WordFromList: FC<CardProps> = ({ content, id, style }) => (
  <>
    {/* Długi zwrot dostaje mniejszą czcionkę, żeby zmieścił się w karcie (na telefonie) */}
    <FitText
      className={classes.word}
      id={id}
      style={style}
    >
      {content}
    </FitText>
  </>
);

export default WordFromList;
